import { SiteStatistic } from "Models/site";
import React from "react";
import { connect } from "react-redux";
import { StatusMapProps } from "./type";
import "./index.scss";
import { Icon } from "shared";
import t from "utils/Lang";

const StatusMap = ({ currentStatus }: StatusMapProps) => {
  return (
    <div className="site-status-container">
      <span>{t().site_listing__status}: </span>
      <Icon
        customClassName="site-status__icon"
        fill={false}
        name="hourglass_empty"
      />
      <span className="site-status__name">{currentStatus.name}</span>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {};
};

export default connect(mapStateToProps)(StatusMap);
